import { useRef, useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Sidebar.css";
import logo from "../../assets/Images/App Icon.png";

import {
  Bell,
  BookText,
  ImageOff,
  Images,
  Info,
  LayoutDashboard,
  LayoutList,
  List,
  MessageSquareWarning,
  UsersRound,
  X,
} from "lucide-react";
import Menu from "./Menu";

const Sidebar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [shownotification, setShownotification] = useState(false);
  const [showmenu, setShowmenu] = useState(false);
  const location = useLocation();
  const sidebarRef = useRef(null);
  const menuref = useRef();
  const profile = JSON.parse(localStorage.getItem("Data"))?.image;

  useEffect(() => {
    const handler = (event) => {
      if (!menuref.current?.contains(event.target)) {
        setShownotification(false);
        setShowmenu(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setMobileOpen(false);
    };
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, []);

  const CheckPath = (path) => location.pathname === path;

  return (
    <div ref={sidebarRef}>
      <div className="appbar">
        <button
          className="menu-button"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label={mobileOpen ? "Close navigation" : "Open navigation"}
          aria-expanded={mobileOpen}
          aria-controls="admin-sidebar"
        >
          ☰
        </button>

        <div className="appbar-controls">
          <img
            alt="profile"
            src={profile}
            className="profile-image"
            onClick={() => setShowmenu(true)}
          />
        </div>
      </div>

      <button
        type="button"
        className={`sidebar-backdrop ${mobileOpen ? "show" : ""}`}
        onClick={() => setMobileOpen(false)}
        aria-label="Close navigation"
      />

      <div id="admin-sidebar" className={`sidebar ${mobileOpen ? "open" : ""}`}>
        <div className="sidebar-content">
          <button type="button" className="sidebar-close" onClick={() => setMobileOpen(false)} aria-label="Close navigation">
            <X />
          </button>
          <div className="sidebar-logo">
            <img src={logo} alt="Qesdo" />{" "}
          </div>
          <ul className="sidebar-list">
            <li className={CheckPath("/Dashboard") ? "selected" : ""}>
              <Link to="/Dashboard" onClick={() => setMobileOpen(false)}>
                <LayoutDashboard />
                <span className="label">Dashboard</span>
              </Link>
            </li>
            <li className={CheckPath("/Behaviour") ? "selected" : ""}>
              <Link to="/Behaviour" onClick={() => setMobileOpen(false)}>
                <UsersRound /> <span className="label">Behaviour Analysis</span>
              </Link>
            </li>
            <li className={CheckPath("/User_List") ? "selected" : ""}>
              <Link to="/User_List" onClick={() => setMobileOpen(false)}>
                <UsersRound /> <span className="label">Users</span>
              </Link>
            </li>

            <li className={CheckPath("/Category_List") ? "selected" : ""}>
              <Link to="/Category_List" onClick={() => setMobileOpen(false)}>
                <LayoutList /> <span className="label">Category</span>
              </Link>
            </li>
            {/* <li className={CheckPath("/Subcategory_List") ? "selected" : ""}>
              <Link to="/Subcategory_List" onClick={() => setMobileOpen(false)}>
                <List /> <span className="label">SubCategory</span>
              </Link>
            </li> */}
            <li className={CheckPath("/Maintenance") ? "selected" : ""}>
              <Link
                to="/Maintenance"
                onClick={() => setMobileOpen(false)}
              >
                <Info /> <span className="label">Maintenance</span>
              </Link>
            </li>
            <li className={CheckPath("/Push_Notification") ? "selected" : ""}>
              <Link
                to="/Push_Notification"
                onClick={() => setMobileOpen(false)}
              >
                <Bell /> <span className="label">Push Notification</span>
              </Link>
            </li>
            <li className={CheckPath("/Posts") ? "selected" : ""}>
              <Link to="/Posts" onClick={() => setMobileOpen(false)}>
                <Images /> <span className="label">Posts</span>
              </Link>
            </li>
            <li className={CheckPath("/Cacelled_Post") ? "selected" : ""}>
              <Link to="/Cacelled_Post" onClick={() => setMobileOpen(false)}>
                <ImageOff /> <span className="label">Cancelled Posts</span>
              </Link>
            </li>
            <li className={CheckPath("/Customer_service") ? "selected" : ""}>
              <Link to="/Customer_service" onClick={() => setMobileOpen(false)}>
                <BookText /> <span className="label">Customer Services</span>
              </Link>
            </li>
            <li className={CheckPath("/Reports") ? "selected" : ""}>
              <Link to="/Reports" onClick={() => setMobileOpen(false)}>
                <MessageSquareWarning />
                <span className="label">Reports</span>
              </Link>
            </li>

            {/* <li className={CheckPath("/Trash") ? "selected" : ""}>
              <Link to="/Trash" onClick={() => setMobileOpen(false)}>
                <Trash2 /> <span className="label">Trash</span>
              </Link>
            </li> */}

            {/*
            {isUserDetailsPath() && (
              <li className="selected">
                <div onClick={() => setMobileOpen(false)}>
                  <span className="icon">📄</span>
                  <span className="label">User Details</span>
                </div>
              </li>
            )}

            <li className={CheckPath("/Report_List") ? "selected" : ""}>
              <Link to="/Report_List" onClick={() => setMobileOpen(false)}>
                <span className="icon">⚠️</span>
                <span className="label">Reports</span>
              </Link>
            </li> */}
          </ul>
        </div>
      </div>

      <div ref={menuref}>{showmenu && <Menu showmenu={setShowmenu} />}</div>
    </div>
  );
};

export default Sidebar;
